import { generateOAuthState, saveOAuthState, getOAuthState, clearOAuthState } from '@/utils/oauthState';

export const useGoogleOAuthState = () => {
  const createState = (): string => {
    const state = generateOAuthState();
    saveOAuthState(state);
    return state;
  };

  const validateState = (returnedState: string | null) => {
    const storedState = getOAuthState();

    if (!returnedState || !storedState) {
      return false;
    }

    if (returnedState !== storedState) {
      return false;
    }

    clearOAuthState();
    return true;
  };

  return {
    createState,
    validateState,
  };
};
